import {
  fetchListing,
} from '@/api/invitation';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, query = null) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchListing({ page: state.pagination.page, query })
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        if (res.items && res.pagination) {
          commit('setResponse', res);
        }
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve invitations',
          () => commit('reset')
        )
      )
    ;
  },
  fetchUser(context, userId) {
    const { commit } = context;
    commit('setIsLoading', true);
    return fetchListing({ pagination: false, userId})
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        if (res.items && res.pagination) {
          commit('setResponse', res);
        }
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve invitations',
          () => commit('reset')
        )
      )
    ;
  },
};
